import { useState } from "react";
import { Plus, ShieldCheck, Trash2, Activity, Pencil } from "lucide-react";
import { Page, Panel, Table, StatusPill } from "../lib/ui";
import { humanDate } from "../lib/api";

const PERM_LABELS = {
  manage_users: "Kullanıcı yönetimi",
  view_banks: "Banka & kasa görüntüle",
  view_cheques: "Çek görüntüle",
  // Gelir/Gider
  create_record: "Gelir/Gider ekleme",
  edit_record: "Gelir/Gider düzenleme",
  delete_income: "Gelir silme",
  delete_expense: "Gider silme",
  // Faturalar
  create_invoice: "Fatura oluşturma",
  edit_invoice: "Fatura düzenleme",
  delete_invoice: "Fatura silme",
  // Cariler
  create_customer: "Cari ekleme",
  edit_customer: "Cari düzenleme",
  delete_customer: "Cari silme",
  // Stok
  create_stock: "Stok ekleme",
  edit_stock: "Stok düzenleme",
  delete_stock: "Stok silme",
  // Hizmet kataloğu
  create_service_item: "Hizmet (katalog) ekleme",
  edit_service_item: "Hizmet (katalog) düzenleme",
  delete_service_item: "Hizmet (katalog) silme",
  // Banka/Kasa hesapları
  create_bank: "Banka/Kasa hesabı ekleme",
  edit_bank: "Banka/Kasa hesabı düzenleme",
  delete_bank: "Banka/Kasa hesabı silme",
  // Hareketler
  create_transaction: "Hareket (tahsilat/ödeme) ekleme",
  edit_transaction: "Hareket düzenleme",
  delete_transaction: "Hareket silme",
  // Çekler
  create_cheque: "Çek ekleme",
  edit_cheque: "Çek düzenleme/ciro",
  delete_cheque: "Çek silme",
  // Servis fişleri
  create_service_ticket: "Servis fişi ekleme",
  edit_service_ticket: "Servis fişi düzenleme",
  delete_service_ticket: "Servis fişi silme",
  // Garanti
  create_warranty: "Garanti kaydı ekleme",
  edit_warranty: "Garanti kaydı düzenleme",
  delete_warranty: "Garanti kaydı silme",
  // Randevular
  create_appointment: "Randevu ekleme",
  edit_appointment: "Randevu düzenleme",
  delete_appointment: "Randevu silme",
  // Alım faturaları
  create_purchase: "Alım faturası oluşturma",
  edit_purchase: "Alım faturası düzenleme",
  delete_purchase: "Alım faturası silme",
  // İş fişleri
  edit_work_order: "İş Takip yetkilisi (tüm iş fişlerini düzenler)",
  delete_work_order: "İş fişi silme",
  // Panel erişimi
  access_accounting: "Muhasebe paneline giriş",
  view_daily_report: "Günlük rapor (PDF) alma",
  // Geçmiş tarihli işlemler
  history_record: "Gelir/Gider: geçmiş tarihli ekleme/düzenleme/silme",
  history_invoice: "Faturalar: geçmiş tarihli ekleme/düzenleme/silme",
  history_purchase: "Alım faturaları: geçmiş tarihli ekleme/düzenleme/silme",
  history_transaction: "Kasa/Banka hareketleri: geçmiş tarihli ekleme/düzenleme/silme",
  history_cheque: "Çekler: geçmiş tarihli ekleme/düzenleme/silme",
  history_payroll: "Maaş: geçmiş tarihli kayıt silme",
  history_work_order: "İş fişleri: geçmiş tarihli düzenleme/silme",
  history_service_ticket: "Servis: geçmiş tarihli düzenleme/silme",
  history_warranty: "Garanti: geçmiş tarihli silme",
  history_appointment: "Randevular: geçmiş tarihli düzenleme/silme",
  history_install: "UTTS ve Takip: geçmiş tarihli düzenleme/silme",
  // Modül görüntüleme
  view_work_orders: "İş Takip paneli erişimi",
  manage_purchase_invoices: "Alım Faturaları menüsü erişimi",
  manage_service: "Servis menüsü erişimi",
  manage_warranty: "Garanti menüsü erişimi",
  view_utts: "UTTS ve Takip montaj kaydı girme / görme",
  manage_utts: "UTTS ve Takip: faturalandı işaretleme, düzenleme, silme",
  view_price_list: "Fiyat Listesi görüntüleme",
  edit_price_list: "Fiyat listesi oluşturma / düzenleme",
  manage_payroll: "Maaş & Personel modülü",
};

export default function Users({ rows, setModal, onDelete, onEditPerms, me }) {
  return (
    <>
      <Page
        eyebrow="EKİP & YETKİLER"
        title="Kullanıcılar"
        subtitle="Kullanıcı ekleyin ve modül bazlı yetkilerini yönetin."
        action={
          <button data-testid="add-users-button" className="primary-button" onClick={() => setModal({ type: "user" })}>
            <Plus size={17} /> Yeni kullanıcı
          </button>
        }
      />

      <Panel className="module-panel">
        <Table
          testid="users-table"
          columns={[
            { label: "Kullanıcı" }, { label: "Rol" }, { label: "Yetkiler" }, { label: "Eklenme" }, { label: "" },
          ]}
          rows={rows}
          empty="Henüz kullanıcı yok."
          renderRow={(u) => {
            const perms = Object.entries(u.permissions || {}).filter(([, v]) => v).map(([k]) => k);
            return (
              <tr key={u.id} data-testid={`user-row-${u.id}`}>
                <td>
                  <strong>{u.name}</strong>
                  <small>{u.email}</small>
                </td>
                <td>
                  <StatusPill status={u.role === "admin" ? "Ödendi" : "Bekliyor"} />
                  <small style={{ marginTop: 6 }}>{u.role === "admin" ? "Yönetici" : "Standart kullanıcı"}</small>
                </td>
                <td>
                  <div className="perm-list">
                    {u.role === "admin" ? (
                      <span className="perm-tag full"><ShieldCheck size={11} /> Tüm yetkiler</span>
                    ) : perms.length ? (
                      perms.slice(0, 4).map((p) => (
                        <span key={p} className="perm-tag">{PERM_LABELS[p] || p}</span>
                      ))
                    ) : (
                      <span className="perm-tag muted">Yetki tanımlanmadı</span>
                    )}
                    {perms.length > 4 && <span className="perm-tag muted">+{perms.length - 4}</span>}
                  </div>
                </td>
                <td>{humanDate(u.created_at)}</td>
                <td className="amount actions-cell">
                  <button data-testid={`user-activity-${u.id}`} className="row-icon tone-muted"
                          title="İşlem geçmişi" onClick={() => setModal({ type: "user-activity", userId: u.id })}>
                    <Activity size={15} />
                  </button>
                  {(u.role !== "admin" || u.id === me?.id) && (
                    <button data-testid={`edit-perms-${u.id}`} className="row-icon tone-muted" title="Düzenle (bilgiler, şifre, yetkiler)" onClick={() => onEditPerms(u)}>
                      <Pencil size={15} />
                    </button>
                  )}
                  {u.role !== "admin" && (
                    <>
                      <button data-testid={`delete-user-${u.id}`} className="row-icon tone-danger" onClick={() => onDelete(u)}>
                        <Trash2 size={15} />
                      </button>
                    </>
                  )}
                </td>
              </tr>
            );
          }}
        />
      </Panel>
    </>
  );
}

export { PERM_LABELS };
